import React, { useCallback } from 'react'
import { I18n } from '@front/volcanion'

import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'
import { Box, Grid } from '@mui/material'

import Form from '@abra/frames/Option/List/Form'
import Header from '@abra/frames/Option/List/Header'
import Row from '@abra/frames/Option/List/Row'

import Callbacks from './callbacks'

const VehicleOption = props => {
  const formToFilter = useCallback(Callbacks.formToFilterHandler(), [])
  return (
    <Box sx={{ p: 2 }}>
      <Grid container justifyContent='center'>
        <Grid size={11}>
          <SearchFrame
            model_name={'vehicleoption'}
            populate={['categoryoption']}
            createButtonProps={{ label: I18n.t('options.vehicleoption.add') }}
          >
            <SearchForm submitOnMount formToFilter={formToFilter}>
              <FormContent>
                <Form title={I18n.t('options.vehicleoption.search')} type='vehicle' />
              </FormContent>
            </SearchForm>
            <SearchTable>
              <TableHeader><Header /></TableHeader>
              <TableRow><Row /></TableRow>
            </SearchTable>
          </SearchFrame>
        </Grid>
      </Grid>
    </Box >
  );
}

export default React.memo(VehicleOption)
